import { normalizeTitleAction, TITLE_ACTION_GROUPS } from "./title-action-definitions";

// Pages describe available actions and their priority; Title owns their presentation.
// Legacy `items` menus are flattened as groups during the migration.
export function titleActions(actions = [], locale = "fr") {
    const groups = [];
    let current = [];
    const flush = () => { if (current.length) groups.push(current); current = []; };
    const visit = (entries, inherited = {}) => entries.filter(Boolean).forEach(entry => {
        if (entry.hidden) return;
        if (entry.divider) { flush(); return; }
        if (entry.items) {
            flush();
            visit(entry.items, {
                disabled: inherited.disabled || entry.disabled,
                loading: inherited.loading || entry.loading,
                tooltip: entry.tooltip || inherited.tooltip,
                main: entry.main ?? inherited.main,
                priority: entry.priority ?? inherited.priority,
            });
            flush();
        } else {
            current.push(normalizeTitleAction({ ...entry,
                main: entry.main ?? inherited.main,
                priority: entry.priority ?? inherited.priority,
                disabled: !!(inherited.disabled || entry.disabled),
                loading: !!(inherited.loading || entry.loading),
                tooltip: entry.tooltip || inherited.tooltip,
            }, locale));
        }
    });
    visit(actions || []);
    flush();
    const all = groups.flat();
    const ranked = [...all].sort((a, b) =>
        (b.priority ?? (b.main ? 100 : 0)) - (a.priority ?? (a.main ? 100 : 0)));
    const candidates = ranked.filter(action => !action.secondary);
    const primary = candidates.find(action => !action.disabled) || candidates[0] || null;
    const grouped = new Map();
    groups.forEach((group, index) => group.forEach(action => {
        if (action === primary) return;
        const key = action.group || `custom-${index}`;
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(action);
    }));
    const order = key => {
        const index = TITLE_ACTION_GROUPS.indexOf(key);
        return index < 0 ? TITLE_ACTION_GROUPS.length : index;
    };
    return { primary, groups: [...grouped.entries()]
        .sort(([a], [b]) => order(a) - order(b)).map(([, group]) => group) };
}
